import { PromoCTAButtonCompare } from './PromoCTAButtonCompare';

import type { Discount } from '../utils/getBestDiscount';

interface FirmForPromoCTA {
  id: string;
  affiliateLink?: string;
  fee?: number;
  discounts?: Discount[];
}

interface Props {
  firm: FirmForPromoCTA;
  isBestValue?: boolean;
  className?: string;
}

export const PromoCTAButtonHomepage = ({ firm, isBestValue = false, className = '' }: Props) => {
  const now = new Date();
  const discount = firm.discounts?.find(d => !d.validUntil || new Date(d.validUntil) > now);

  const code = discount?.code ?? null;
  const percent = discount?.percent ?? null;
  const validUntil = discount?.validUntil ?? null;
  const validUntilRemark = discount?.validUntilRemark ?? null;
  const firstPurchaseOnly = discount?.firstPurchaseOnly ?? false;
  const fee = firm.fee;
  const affiliateLink = firm.affiliateLink;

  return (
    <PromoCTAButtonCompare
      firmId={firm.id}
      affiliateLink={affiliateLink}
      code={code}
      percent={percent}
      validUntil={validUntil}
      validUntilRemark={validUntilRemark}
      firstPurchaseOnly={firstPurchaseOnly}
      className={className}
      fee={fee}
      isBestValue={isBestValue}
    />
  );
};

export default PromoCTAButtonHomepage;
